module.exports = __webpack_public_path__ + "assets/27162b1e527ea6aac38eb16df280e495.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/mystery/PostEfxSmall.mp3
 ** module id = 352
 ** module chunks = 0
 **/